import * as api from "Api";
import * as actions from "Actions";

export const fetchFiduciaryData = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    let organizationUen = currentOrganization && currentOrganization.uen;
    let data = {
      organizationUen
    };
    return dispatch(actions.fetchFiduciaryData(api.getFiduciaryData(data)));
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/fiduciary.js